module.exports = __webpack_public_path__ + "static/img/coupon_empty2@3x.829b9309.png";